import { FOCUS_VISIBLE_STYLE_LIGHT } from "app/theme";
import { css } from "styled-components/macro";

export const headercss = css`
  width: 100%;
  height: 100%;

  background-color: #fff;

  a {
    text-decoration: none;
    color: #231d2c;
    font-size: 14px;
    :hover {
      color: #6061e5;
    }
  }
`;

export const logocss = css`
  display: flex;
  justify-content: center;
  gap: 6px;
  text-decoration: none;
  :focus-visible {
    ${FOCUS_VISIBLE_STYLE_LIGHT}
  }
`;

export const navLinkcss = (display: string, location: string) => css`
  a {
    color: ${display === location ? "#6061E5 !important" : "#231D2C"};
    :focus-visible {
      ${FOCUS_VISIBLE_STYLE_LIGHT}
    }
  }
`;
